module.exports = __webpack_public_path__ + "f5ff29c8262f8a6fadb2c273a0c8d9d7.jpg";